import {
    CallAdapter,
    CallAndChatLocator,
    CallWithChatAdapter,
    CallWithChatComposite,
    createAzureCommunicationCallWithChatAdapterFromClients,
    onResolveVideoEffectDependencyLazy,
    StatefulCallClient,
    StatefulChatClient,
} from "@azure/communication-react";
import { CallAgent } from "@azure/communication-calling";
import React, { useEffect, useState } from "react";
import { fetchThreads } from "../utils";
import { groupChatThreadTopic } from "../store/chatConstants";

interface StudentCallWithChatCompositeProps {
    locator: CallAndChatLocator;
    callAgent?: CallAgent;
    callClient?: StatefulCallClient;
    chatClient?: StatefulChatClient;
    threadId: string;
    callAdapter?: CallAdapter;
    isMobile: boolean;
}

export function TestCallWithChatComposite(props: StudentCallWithChatCompositeProps): JSX.Element {

    const { callAgent, callClient, chatClient, callAdapter, isMobile } = props;

    // The static `threadId` prop is no longer populated (pcp resolves multiple chat threads
    // dynamically by topic). Resolve the group chat thread ("Gruppenchat") at runtime so the
    // composite has a valid thread to attach to — mirrors `useSyncClientStates`.
    const [resolvedThreadId, setResolvedThreadId] = useState<string | undefined>(undefined);
    useEffect(() => {
        if (!chatClient) {
            return;
        }
        const resolve = () => {
            const groupChat = Object
                .values(chatClient.getState().threads)
                .find(t => t.properties?.topic === groupChatThreadTopic);
            if (groupChat?.threadId) {
                setResolvedThreadId(groupChat.threadId);
            }
        };
        // populate `chatClient` state with the available threads, then resolve
        fetchThreads(chatClient).then(resolve).catch(console.error);
        chatClient.onStateChange(resolve);
        return () => chatClient.offStateChange(resolve);
    }, [chatClient]);

    const [callWithChatAdapter, setCallWithChatAdapter] = useState<CallWithChatAdapter | undefined>(undefined);
    useEffect(() => {
        (async () => {
            if ('groupId' in props.locator.callLocator && resolvedThreadId && callAdapter && callAgent && callClient && chatClient) {
                const chatThreadClient = chatClient.getChatThreadClient(resolvedThreadId);

                const callWithChatAdapter = await createAzureCommunicationCallWithChatAdapterFromClients({
                    callClient,
                    callAgent,
                    chatClient,
                    chatThreadClient,
                    // callLocator: { groupId: props.locator.callLocator.groupId },
                    // TODO: using ACS groupID as roomID for now
                    callLocator: { roomId: props.locator.callLocator.groupId },
                    callAdapterOptions: {
                        videoBackgroundOptions: {
                            onResolveDependency: onResolveVideoEffectDependencyLazy,
                        }
                    }
                });
                setCallWithChatAdapter(callWithChatAdapter);
            }
        })();
    }, [callAdapter, callAgent, callClient, chatClient, props.locator.callLocator, resolvedThreadId]);

    if (!callWithChatAdapter) {
        return <div>Loading...</div>;
    }

    return (
        <div style={{ height: '100vh' }}>
                <CallWithChatComposite adapter={callWithChatAdapter} formFactor={isMobile ? 'mobile' : 'desktop'} />
            </div>
    )
}
